import { useEffect, useState } from "react";
import { useLang } from "@/i18n";
import api, { errMsg } from "@/api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

const STATUS_KEYS = ["new", "contacted", "converted", "closed"];

export default function ConsultsTab({ onChanged }) {
  const { t } = useLang();
  const [consults, setConsults] = useState([]);

  const load = () => api.get("/admin/consults").then((r) => setConsults(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    try {
      await api.patch(`/admin/consults/${id}`, { status });
      load();
      onChanged?.();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div className="space-y-3" data-testid="consults-tab">
      <h2 className="font-serif font-semibold text-lg">{t("admin.consultRequests")}</h2>
      {consults.length === 0 && <p className="text-muted-foreground">{t("admin.noData")}</p>}
      {consults.map((c) => (
        <Card key={c.id} data-testid={`consult-row-${c.id}`}>
          <CardContent className="p-4 flex flex-wrap items-center justify-between gap-3">
            <div>
              <p className="font-semibold">{c.name} <span className="font-normal text-muted-foreground">· {c.email}</span></p>
              <p className="text-sm text-muted-foreground mt-0.5">{t(`goals.${c.goal}`) || c.goal}{c.message ? ` — ${c.message}` : ""}</p>
              <p className="text-xs text-muted-foreground mt-0.5">{new Date(c.created_at).toLocaleString()}</p>
            </div>
            <Select value={c.status} onValueChange={(v) => setStatus(c.id, v)}>
              <SelectTrigger className="w-40" data-testid={`consult-status-${c.id}`}><SelectValue /></SelectTrigger>
              <SelectContent>
                {STATUS_KEYS.map((s) => (
                  <SelectItem key={s} value={s} data-testid={`consult-status-${c.id}-${s}`}>{t(`admin.status${s[0].toUpperCase() + s.slice(1)}`)}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
